import type { ConfluenceInlineComment } from '../../types';

export const isConfluenceInlineComment = (entity: any): entity is ConfluenceInlineComment =>
	entity.__typename === 'ConfluenceInlineComment';

export const getConfluenceInlineCommentLink = (comment: ConfluenceInlineComment): string | null => {
	const { base, webUi } = comment.links ?? {};

	if (base === undefined || webUi === undefined || base.length === 0 || webUi.length === 0) {
		return null;
	}

	return `${base}${webUi}`;
};
